import { render, staticRenderFns } from "./order-view-claim.vue?vue&type=template&id=363b22e1&"
import script from "./order-view-claim.vue?vue&type=script&lang=js&"
export * from "./order-view-claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports